import React from 'react';

const VizzTheme = {
  headerLogo: {
    src: '/themes/theme/vizz/logo.png',
    alt: 'Vizz Agency Logo',
  },
  darkLogo: {
    src: '/themes/theme/vizz/logo.png',
    alt: 'Vizz Agency Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Vizz Agency',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="120" src="/themes/theme/vizz/logo.png" alt="Vizz Agency Logo" />
      <br /><br />
      <h3>Vizz Agency Influencers</h3>
    </div>
  ),
  shareSite: 'https://vizzr.dyzio.co',
};

export default VizzTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/vizz.js
 **/